export const developmentTextContent = {
  headingText: "Development",
  btnText: "Contact Us",
  content: [
    {
      titleText: "Frontend",
      subtitleText: "Our tailored front-end services offer you:",
      listContent: [
        { listText: "Compelling UI interface" },
        { listText: "Responsive design" },
        { listText: "Top-notch animations" },
        { listText: "Audio & Sound Effects" },
        { listText: "Interactive Elements" },
        { listText: "Player Profile & Settings" },
        { listText: "Social Features" },
        { listText: "Engagement Features" },
      ],
    },
    {
      titleText: "Backend",
      subtitleText: "We offer backend tools for efficient business management:",
      listContent: [
        { listText: "Game Server Frameworks" },
        { listText: "Database Management Systems" },
        { listText: "Payment Gateways" },
        { listText: "Random Number Generator" },
        { listText: "Analytics & Reporting Tools" },
        { listText: "Player Management Tools" },
        { listText: "Anti-fraud Systems" },
      ],
    },
    {
      titleText: "Quality Check",
      subtitleText: "Our QA teams ensure flawless gameplay, high performance, and fairness:",
      listContent: [
        { listText: "Functionality" },
        { listText: "Compatibility" },
        { listText: "Random Number Generator" },
        { listText: "Compliance" },
        { listText: "Payout and Win" },
        { listText: "Security" },
        { listText: "Regression" },
      ],
    },
    {
      titleText: "Build & Deploy",
      subtitleText: "We build and deploy next-gen slot games ensuring flawless performance across all devices:",
      listContent: [
        { listText: "Version Control" },
        { listText: "Fast Rollouts" },
        { listText: "Seamless Integrations" },
        { listText: "Cross-platform Compatibility" },
        { listText: "Scalable Architecture" },
        { listText: "Regulatory Compliance" },
        { listText: "Post-launch Maintenance" },
      ],
    },
    {
      titleText: "Bet & Earn",
      subtitleText: "Your Players can bet on the spin and win exciting rewards:",
      listContent: [
        { listText: "Diverse Betting Options" },
        { listText: "Varying Bet Sizes" },
        { listText: "Progressive Jackpots" },
        { listText: "Bonus Rounds" },
        { listText: "Free Spins" },
        { listText: "Autoplay" },
        { listText: "Instant Wins" },
      ],
    },
    {
      titleText: "Assurance",
      subtitleText: "Maximize engagement with our assured reward system:",
      listContent: [
        { listText: "Guaranteed Bonus" },
        { listText: "Guaranteed Payouts" },
        { listText: "Progressive Win Multipliers" },
        { listText: "Guaranteed Free Spins" },
        { listText: "Multiplier Boosts" },
        { listText: "Loyalty Rewards" },
        { listText: "Level-Up Rewards" },
      ],
    },
  ],
};
